import { IncidentDetails } from "./IncidentDetails";

export default IncidentDetails;
